import React, { useEffect, useState, useCallback } from "react";
import Layout from "containers/LayoutV2";
import { format } from "date-fns";
import QuanLyCongViecApi from "service/QuanLyCongViec/QuanLyCongViecApi";
import StoreApi from "service/phanQuyenApi";
import { SearchBarDesktop } from "./SearchBarDestop";
import { TableDanhSach } from "./TableDanhSach";
import configsRole from "utils/configsRole";

export const QuanLiCongViec = () => {
  const initPhanQuyen = {
    quanlycongviec: false,
    quanlycongviec_themcongviec: false,
    quanlycongviec_suacongviec: false,
    quanlycongviec_xoacongviec: false,
    quanlycongviec_giahan: false,
    quanlycongviec_danhgia: false,
    quanlycongviec_giaochonguoikhac: false,
  };
  const [phanQuyen, setPhanQuyen] = useState(initPhanQuyen);
  const [loading, setLoading] = useState(true);

  const initialDataSearch = {
    nhanVien: "",
    fromDate: null,
    toDate: null,
    pageIndex: 1,
    pageSize: 25,
  };
  const [dataSearch, setDataSearch] = useState(initialDataSearch);
  const [listDanhSach, setListDanhSach] = useState({ List: [], iTotal: 0 });
  const [isLoadingList, setIsLoadingList] = useState(false);

  const handleGetData = useCallback((searchParams) => {
    setIsLoadingList(true);
    const params = {
      ...searchParams,
      fromDate: searchParams.fromDate
        ? format(searchParams.fromDate, "dd/MM/yyyy")
        : null,
      toDate: searchParams.toDate
        ? format(searchParams.toDate, "dd/MM/yyyy")
        : null,
    };
    QuanLyCongViecApi.getTasks(params)
      .then((res) => {
        if (res.status === 200) {
          setListDanhSach({
            List: res.data.List || [],
            iTotal: res.data.iTotal || 0,
          });
        } else {
          setListDanhSach({ List: [], iTotal: 0 });
        }
      })
      .catch(() => setListDanhSach({ List: [], iTotal: 0 }))
      .finally(() => setIsLoadingList(false));
  }, []);

  const handleReloadList = useCallback(() => {
    handleGetData(dataSearch);
  }, [dataSearch, handleGetData]);

  useEffect(() => {
    if (phanQuyen.quanlycongviec) {
      handleGetData(dataSearch);
    }
  }, [phanQuyen.quanlycongviec]);

  const LoadPhanQuyen = () => {
    setLoading(true);
    StoreApi.getAllQuyen()
      .then((resQuyen) => {
        if (resQuyen.status === 200) {
          const getRole = (code) =>
            resQuyen.data.some(
              (e) => e.ModuleCode?.toUpperCase() === code.toUpperCase()
            );
          setPhanQuyen({
            quanlycongviec: getRole(configsRole.sRole.quanlycongviec),
            quanlycongviec_themcongviec: getRole(
              configsRole.sRole.quanlycongviec_themcongviec
            ),
            quanlycongviec_suacongviec: getRole(
              configsRole.sRole.quanlycongviec_suacongviec
            ),
            quanlycongviec_xoacongviec: getRole(
              configsRole.sRole.quanlycongviec_xoacongviec
            ),
            quanlycongviec_giahan: getRole(
              configsRole.sRole.quanlycongviec_giahan
            ),
            quanlycongviec_danhgia: getRole(
              configsRole.sRole.quanlycongviec_danhgia
            ),
            quanlycongviec_giaochonguoikhac: getRole(
              configsRole.sRole.quanlycongviec_giaochonguoikhac
            ),
          });
        }
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    document.title = "Quản lý công việc | Phần mềm Morman";
    LoadPhanQuyen();
  }, []);

  // if (loading) return null;

  return (
    <Layout>
      {phanQuyen.quanlycongviec ? (
        <div id="form-repeater" className="p-1">
          <div
            className="breadcrumb-new hidden-mobile-main"
            style={{ marginBottom: "5px" }}
          >
            <div className="row header justify-content-start">
              <img
                src="/app-assets/images/icon-quan-ly-cong-viec.png"
                alt="Công việc"
              />
              <h1 className="text-info-home">Quản lý công việc</h1>
            </div>
          </div>
          <div>
            <SearchBarDesktop
              dataSearch={dataSearch}
              setDataSearch={setDataSearch}
              onSearch={handleGetData}
            />
            <TableDanhSach
              phanQuyen={phanQuyen}
              listDanhSach={listDanhSach}
              isLoading={isLoadingList}
              dataSearch={dataSearch}
              setDataSearch={setDataSearch}
              onReload={handleReloadList}
              onSearch={handleGetData}
            />
          </div>
        </div>
      ) : (
        <div className="p-1 text-center text-danger">
          Bạn không có quyền truy cập chức năng này.
        </div>
      )}
    </Layout>
  );
};
